// Einmalige Konsolenmeldungen für Config-Fehler.
//
// Zieht aus applyColumnConfig.ts um, weil ab jetzt zwei Module melden: der
// Katalog über unbekannte Keys in fieldVisibility.globalHidden, die
// Spalten-Pipeline über unbekannte Keys in fieldVisibility.jobTables.
//
// Einmal je Tippfehler, nicht je Render: welcher Aufrufer seine Props
// memoisiert, darf nicht bestimmen, wie oft die Meldung erscheint.
const warned = new Set<string>();

export function warnOnce(marker: string, message: string): void {
    if (warned.has(marker)) return;
    warned.add(marker);
    console.warn(message);
}

/** Nur für Tests: leert die Merkliste der schon gemeldeten Meldungen. */
export function __resetWarnings(): void {
    warned.clear();
}
